import type { Validation } from "@/lib/validation"

export const validationStructures: Validation.StructureOption[] = [
  `array`,
  `collection`,
  `item`,
  `mirror`,
]

export const validationStructuresCollection: Record<
  Validation.StructureOption,
  true
> = {
  array: true,
  collection: true,
  item: true,
  mirror: true,
}
